import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";

import { Link } from "react-router-dom";

import { useGetWebsiteProductsQuery } from "../../../features/api/websiteApi";
import { useState } from "react";
import { MdAdd } from "react-icons/md";
import { API_BASE_URL } from "../../../components/baseUrl";

const Products = () => {
  const { data: products, error, isLoading } = useGetWebsiteProductsQuery();

  const [searchTerm, setSearchTerm] = useState("");

  const filterSearch = searchTerm
    ? products?.filter(
        (d) =>
          d?.title?.toLowerCase()?.includes(searchTerm?.toLocaleLowerCase()) ||
          d?.short_desc
            ?.toLowerCase()
            ?.includes(searchTerm?.toLocaleLowerCase()) ||
          d?.long_desc?.toLowerCase()?.includes(searchTerm?.toLocaleLowerCase())
      )
    : products;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Something went wrong!</p>;

  return (
    <div>
      <div className="flex justify-between items-center px-12 my-6">
        <h1 className="text-xl font-bold">All Products</h1>
        <div className="flex items-start gap-2">
          <Link
            to="/dashboard/website/product-create"
            className="text-white bg-blue-600 uppercase cursor-pointer flex items-center gap-1 px-2 py-1 rounded"
          >
            <span>
              <MdAdd className="text-xl" />
            </span>
            <span>Create Product</span>
          </Link>
        </div>
      </div>
      <input
        type="text"
        placeholder="Search"
        className="border ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="h-[71vh] overflow-auto w-full m-auto px-12 my-5">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : filterSearch?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no message from the website
          </p>
        ) : (
          <TableContainer component={Paper} className="border">
            <Table stickyHeader>
              <TableHead className="bg-blue-500">
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">#</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Image</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Title</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Short Description</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Status</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Created</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterSearch
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => (
                    <TableRow key={row.id || i}>
                      <TableCell>{page * rowsPerPage + i + 1}</TableCell>

                      <TableCell>
                        {row?.image ? (
                          <img
                            src={`${API_BASE_URL}/uploads/${row.image}`}
                            alt={row.title || "product image"}
                            className="w-16 h-16  rounded-full"
                          />
                        ) : (
                          <span className="text-gray-400 italic">No Image</span>
                        )}
                      </TableCell>

                      <TableCell>{row?.title}</TableCell>

                      <TableCell>{row?.short_desc}</TableCell>

                      <TableCell>
                        {row?.status === 1 ? (
                          <span className="text-green-600 font-semibold">
                            Active
                          </span>
                        ) : (
                          <span className="text-red-600 font-semibold">
                            Inactive
                          </span>
                        )}
                      </TableCell>

                      <TableCell>
                        {row?.created_at
                          ? new Date(row.created_at).toLocaleDateString()
                          : "-"}
                      </TableCell>

                      <TableCell>
                        <div className="flex items-center gap-x-4">
                          <Link
                            to={`/dashboard/website/product-view/${row.id}`}
                            state={row}
                            className="border border-blue-600 px-3 py-1 rounded text-blue-600 hover:bg-blue-600 hover:text-white transition"
                          >
                            View
                          </Link>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={filterSearch?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Products;
